<template>
  <div>
    <div class="profile-field__title">Опыт работы</div>

    <c-switcher v-model="hasExperience" label="Есть опыт работы в сфере" />

    <transition name="slide">
      <div
        v-if="hasExperience"
        class="wrapper"
        :class="{
          'phone-error': error && error.phone,
        }"
      >
        <div class="place">
          <c-input
            v-model="organization"
            floating-label="Место последней работы в сфере"
            :clearable="true"
            :max-length="255"
          />
        </div>

        <div class="duration">
          <div class="c-input-label">Продолжительность</div>
          <div class="duration__wrapper">
            <div class="duration__value">
              <c-input v-model="duration" :clearable="true" placeholder="0" type="price-number" />
            </div>

            <div class="duration__unit">
              <c-input v-model="durationUnit" type="select" :items="durationUnits" />
            </div>
          </div>
        </div>

        <div class="position">
          <c-input v-model="position" floating-label="Занимаемая должность" :clearable="true" :max-length="255" />
        </div>

        <div class="phone">
          <c-input
            v-model="phone"
            label="Телефон человека, который может дать рекомендацию"
            :clearable="true"
            placeholder="+7 (___) ___ ____"
            mask="+7 (###) ### ####"
            class="phone__input"
            :required="error && error.phone"
            :required-message="error && error.phone"
          />
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import CInput from "@/components/controls2/Input";
import CSwitcher from "@/components/controls/switcher";

const durationUnits = [
  { label: "месяцев", value: "month" },
  { label: "лет", value: "year" },
];

const [defaultUnit] = durationUnits;

export default {
  components: { CInput, CSwitcher },
  props: ["field", "value", "editable", "error"],
  data() {
    return {
      inited: false,
      hasExperience: false,
      organization: "",
      duration: "",
      durationUnit: defaultUnit,
      position: "",
      phone: "",

      durationUnits,
    };
  },

  watch: {
    hasExperience(v) {
      if (!v) {
        this.organization = "";
        this.duration = "";
        this.durationUnit = defaultUnit;
        this.position = "";
        this.phone = "";
      }
      this.updateValue();
    },
    organization() {
      this.updateValue();
    },
    duration() {
      this.updateValue();
    },
    position() {
      this.updateValue();
    },
    durationUnit() {
      this.updateValue();
    },
    phone() {
      this.updateValue();
    },
    value(v) {
      this.setData(v);
    },
  },

  created() {
    if (this.value) this.setData(this.value);
  },

  methods: {
    setData(value) {
      if (!value) return;
      this.inited = false;

      const { hasExperience, organization, duration, durationUnit, position, phone } = value.value || {};

      this.hasExperience = hasExperience === "0" ? false : !!hasExperience;
      this.organization = organization || "";
      this.duration = duration || "";
      this.durationUnit = durationUnits.find((unit) => unit.value === durationUnit) || defaultUnit;
      this.position = position || "";
      this.phone = phone || "";
      this.$nextTick(() => {
        this.inited = true;
      });
    },

    updateValue() {
      this.$emit("input", {
        value: {
          hasExperience: this.hasExperience ? 1 : 0,
          organization: this.organization,
          duration: this.duration,
          durationUnit: this.durationUnit.value,
          position: this.position,
          phone: this.phone,
        },
      });
      if (this.inited) this.$emit("change");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";

.wrapper {
  margin-left: -15px;
  margin-right: -15px;
  margin-bottom: -15px;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  margin-top: 25px;
}

.place,
.duration,
.position,
.phone {
  padding-left: 15px;
  padding-right: 15px;
  margin-bottom: 25px;
  width: 100%;
}

.phone {
  padding-top: 6px;
}

.duration {
  padding-top: 6px;

  &__wrapper {
    display: flex;
    margin-left: -8px;
    margin-right: -8px;
  }
  &__value,
  &__unit {
    padding-left: 8px;
    padding-right: 8px;
  }
  &__value {
    width: calc(100% / 3);
  }
  &__unit {
    width: calc(100% / 3 * 2);
  }
}

@include bootstrapMd {
  .place {
    width: calc(100% / 10 * 6);
  }
  .duration {
    width: calc(100% / 10 * 3);
    &__wrapper {
      display: flex;
      margin-left: -15px;
      margin-right: -15px;
    }
    &__value,
    &__unit {
      padding-left: 15px;
      padding-right: 15px;
    }
  }
  .position {
    width: calc(100% / 10 * 6);
  }
  .phone {
    width: calc(100% / 10 * 3);
  }

  .phone-error {
    .position {
      padding-bottom: 19px;
    }
  }
}

@include bootstrapLg {
  .place {
    width: calc(100% / 12 * 6);
  }
  .duration {
    width: calc(100% / 12 * 3);
  }
  .position {
    width: calc(100% / 12 * 6);
  }
  .phone {
    width: calc(100% / 12 * 6);

    &__input {
      width: 50%;
    }

    /deep/ {
      .c-input-label {
        white-space: nowrap;
      }
    }
  }
}
</style>
